import {
    StyleSheet
} from "react-native";
import type {
    RadialChartMeasuresConstantType,
    RadialChartDynamicStyleType,
    RadialChartMeasures
} from "./type";

export const RADIAL_CHART_DEFAULT_MAX = 100;

export const RADIAL_CHART_CATEGORY_KEY = "category";

export const RADIAL_CHART_VALUE_KEY = "value";

export const RADIAL_CHART_REMAINING_KEY = "remaining";

export const RADIAL_CHART_CENTER_SHIFT = 0.35;

export const RADIAL_CHART_STACKED_HOLE = 0.3;

export const RADIAL_CHART_BARS_HOLE = 0.15;

export const RADIAL_CHART_BARS_SPAN = Math.PI * 1.5;

export const RADIAL_CHART_GAUGE_SPAN = Math.PI;

export const RADIAL_CHART_FULL_SPAN = Math.PI * 2;

export const RADIAL_CHART_GAUGE_START = -Math.PI / 2;

export const RADIAL_CHART_LIFT_FACTOR = 2;

export const RADIAL_CHART_BAND_FACTOR = 2;

export const getRadialChartMeasures = ({
    shapeConfigs,
    typography,
    borders,
    spaces
}: RadialChartMeasuresConstantType): RadialChartMeasures => {
    return {
        lift: shapeConfigs.chartHaloWidth * RADIAL_CHART_LIFT_FACTOR,
        minThickness: borders.chartLine * RADIAL_CHART_BAND_FACTOR,
        bandWidth: borders.chartLine * RADIAL_CHART_BAND_FACTOR,
        thickness: shapeConfigs.chartRadialThickness,
        labelTypography: typography.bodySmallSize,
        valueSteps: [
            typography.headlineMediumSize,
            typography.headlineSmallSize,
            typography.titleLargeSize,
            typography.titleMediumSize,
            typography.titleSmallSize,
            typography.bodyMediumSize,
            typography.bodySmallSize
        ],
        clearance: spaces.spacingSm,
        margin: spaces.spacingSm,
        gap: spaces.spacingXs
    };
};

const stylesheet = StyleSheet.create({
    chip: {
        alignItems: "center"
    },
    container: {
        width: "100%"
    },
    root: {
        width: "100%"
    }
});

export const useStyles = ({
    colors,
    spaces
}: RadialChartDynamicStyleType) => {
    const styles = {
        track: colors.system.state.overlay.fill.default,
        success: colors.content.icon.success,
        warning: colors.content.icon.warning,
        danger: colors.content.icon.danger,
        value: colors.content.text.high,
        label: colors.content.text.low,
        root: {
            gap: spaces.spacingMd
        }
    };

    return styles;
};
export default stylesheet;
